import "./module/loading.js";
import "./module/menu.js";
import "./module/tab.js";
import "./module/swiper.js";
import "./module/top-mv.js";
import "./module/top-swiper.js";
import "./module/smooth-scroll.js";
import "./module/match-height.js";
import "./module/fade-in.js";
import "./module/experience.js";
import "./module/rooms.js";
import "./module/restaurant.js";
import "./module/follower-banner.js";
import "./module/contact.js";
import "./module/room-list.js";
import "./module/topics.js";
import "./module/accordion.js";
import "./module/access.js";
import "./module/text-animation.js";
import "./module/scroll-hint.js";
import "./module/datepicker.js";
import "./module/search_form.js";

import { goBack } from "./module/back-link.js";
window.goBack = goBack;
